import { render, staticRenderFns } from "./NuevaSucursal.vue?vue&type=template&id=36dd810f"
import script from "./NuevaSucursal.vue?vue&type=script&lang=js"
export * from "./NuevaSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports